import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComplianceRequirement {
  standard: string;
  description: string;
  industries: string[];
  icon: string;
}

interface ComplianceMatrixProps {
  requirements: ComplianceRequirement[];
}

const ComplianceMatrix: React.FC<ComplianceMatrixProps> = ({ requirements }) => {
  return (
    <section className="py-16 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-trust-builder/10 rounded-full mb-4">
              <Icon name="ShieldCheckIcon" size={20} className="text-trust-builder" variant="solid" />
              <span className="text-sm font-cta font-semibold text-trust-builder">Compliance & Certifications</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-headline font-bold text-primary mb-4">
              Regulatory Compliance Matrix
            </h2>
            <p className="text-lg text-muted-foreground font-body max-w-3xl mx-auto">
              We maintain comprehensive certifications and expertise across all major industry compliance standards
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {requirements.map((req, idx) => (
              <div
                key={idx}
                className="bg-card rounded-xl shadow-card hover:shadow-elevated transition-all duration-300 p-6"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-trust-builder/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name={req.icon as any} size={24} className="text-trust-builder" variant="solid" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-headline font-bold text-primary mb-2">{req.standard}</h3>
                    <p className="text-sm text-muted-foreground font-body mb-4">{req.description}</p>
                    <div className="flex flex-wrap gap-2">
                      {req.industries.map((industry, i) => (
                        <span
                          key={i}
                          className="px-3 py-1 bg-brand-secondary/10 text-xs font-cta font-semibold text-brand-secondary rounded-full"
                        >
                          {industry}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceMatrix;